define('views/parts/panel/panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/menu/menu',
    'views/parts/panel/panel-header',
    // templates
    'text!templates/parts/menu/menu-tabs.html',
    'text!templates/parts/panel/panel.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    //Views
    VMenu,
    VPanelHeader,
    // templates
    TMenuTab,
    TPanel
) {

    var VPanel = Backbone.View.extend({
        template: TPanel,
        className: "panel scrollable",
        events: {
            "scroll": "onScroll",
            "resize": "onResize",
        },
        regions: {
            header: '.panel-header',
            tabs: '.menu-tabs',
            content: '.panel-content'
        },

        initialize: function(options) {

            options = this.options = options || {};
            var view = this.view = {};

            if (options.header) {
                view.header = new VPanelHeader(_.extend({
                    context: options.context
                }, options.header));
            }

            if (options.tabs) {

                this.onlyOneTabs = false;
                if (options.tabs.length <= 1) this.onlyOneTabs = true;

                view.tabs = new VMenu({
                    templateItem: TMenuTab,
                    radio: true,
                    collection: new Backbone.Collection(options.tabs),
                    context: options.context
                });
            }

            if (options.content) {
                view.content = options.content;
            }

            Backbone.$(window).on('resize', this.onResize);

        },

        render: function() {

            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            if (view.header) this.assign(view.header, zone.$header);

            // This for remove title on tabs when have only one tab
            if (this.onlyOneTabs) {
                Backbone.$(zone.$tabs).html('<li class=""></li>');
            } else {
                if (view.tabs) this.assign(view.tabs, zone.$tabs);
            }

            this.renderContent();

            return this;
        },

        getContent: function() {
            return this.view.content;
        },

        setContent: function(view) {
            var viewObj = this.view,
                content = viewObj.content;
            if (!this.is(view)) {
                if (content) content.disable({ defer: true });
                viewObj.content = view;
            }
            return this;
        },

        renderContent: function() {
            if (this.view.content && this.zone) {
                this.assign(this.view.content, this.zone.$content, { defer: true });
            }
            // U.log(this);
            this.setActionButtonsWidth(this.$el.context.offsetWidth);

            return this;
        },

        is: function(view) {
            return this.view.content === view;
        },

        setTitle: function(title) {
            this.view.header.setTitle(title);
        },

        setSubtitle: function(subtitle) {
            this.view.header.setSubtitle(subtitle);
        },

        setSpecificTitle: function(specific) {
            this.view.header.setSpecificTitle(specific);
        },

        setActionButtonsWithScroll: function(e) {
            var scrollTop = e.currentTarget.scrollTop;
            var panelWidth = e.currentTarget.offsetWidth;

            var willStickElement = Backbone.$('.panel-content > .panel-body > div.will-stick');
            if (willStickElement.length) {
                if (scrollTop > 100) {
                    willStickElement.addClass('is-fixed');
                    willStickElement.css('width', panelWidth + 'px');
                } else {
                    willStickElement.removeClass('is-fixed');
                    willStickElement.css('width', '100%');
                }
            }

            if (Backbone.$('.panel-content > .panel-body > .menu-actions', this.$el).length > 0) {
                if (scrollTop > 69) {
                    Backbone.$('.panel-content > div > .menu-actions', this.$el).addClass('fixed');
                    Backbone.$('.panel-content > .panel-body', this.$el).addClass('panel-with-action-fixed');
                    this.setActionButtonsWidth(panelWidth);
                } else {
                    Backbone.$('.panel-content > div > .menu-actions', this.$el).removeClass('fixed');
                    Backbone.$('.panel-content > .panel-body', this.$el).removeClass('panel-with-action-fixed');
                }
            }
        },

        setActionButtonsWidth: function(width) {
            Backbone.$('.panel-content > div > .menu-actions', this.$el).css('width', width + "px");
            // Check usages of this if it doesn't cause problems elsewhere
            // if (Backbone.$('.panel-content > .panel-body > div.will-stick')) {
            //     Backbone.$('.panel-content > .panel-body > div.will-stick').css('width', width + "px");
            // }
        },

        onResize: function(e) {
            if (e) {
                // this.setActionButtonsWidth(e.currentTarget.offsetWidth);
                Backbone.$('.panel-content > div > .menu-actions', this.$el).css('width', e.currentTarget.offsetWidth + "px");
            }
        },

        onScroll: function(e) {
            if (e) {
                this.setActionButtonsWithScroll(e);
            }
        }

    });

    return VPanel;
});

